import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import type {
  OnboardingDataColumn,
  OnboardingMonthRow,
} from "./onboardingPlots.types";

function formatValue(value: number | null, column: OnboardingDataColumn) {
  if (value === null || value === undefined) return "–";
  if (column.percent) return `${(value * 100).toFixed(1)}%`;
  return column.decimals != null
    ? value.toFixed(column.decimals)
    : Math.round(value).toLocaleString();
}

export default function DataTableView({
  rows,
  columns,
}: {
  rows: OnboardingMonthRow[];
  columns: OnboardingDataColumn[];
}) {
  const antColumns: ColumnsType<OnboardingMonthRow> = [
    {
      title: "Month",
      dataIndex: "date",
      key: "date",
      fixed: "left",
      width: 110,
    },
    ...columns.map((column) => ({
      title: column.label,
      key: column.label,
      align: "right" as const,
      render: (_: unknown, row: OnboardingMonthRow) =>
        formatValue(column.get(row), column),
    })),
  ];

  return (
    <Table
      size="small"
      rowKey="date"
      pagination={false}
      scroll={{ x: true, y: 320 }}
      dataSource={rows}
      columns={antColumns}
    />
  );
}
